export default __webpack_public_path__ + "static/media/file-icon.6ef18256.svg";